import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';

// Initialize GA4 with your measurement ID
// Replace 'G-XXXXXXXXXX' with your actual Google Analytics 4 measurement ID
const TRACKING_ID = 'G-2W5R6BNCVB';

ReactGA.initialize(TRACKING_ID);

// Custom event tracking function
export const trackEvent = (category, action, label) => {
  ReactGA.event({
    category: category,
    action: action,
    label: label,
  });
};

// Custom page view tracking
export const trackPageView = (path) => {
  ReactGA.send({ hitType: "pageview", page: path });
};

const GoogleAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page views
    trackPageView(location.pathname + location.search);

    // Track specific page events
    switch (location.pathname) {
      case '/contact':
        trackEvent('Page', 'View', 'Contact Page');
        break;
      case '/fee-structure':
        trackEvent('Page', 'View', 'Fee Structure Page');
        break;
      case '/faculty':
        trackEvent('Page', 'View', 'Faculty Page');
        break;
      case '/services':
        trackEvent('Page', 'View', 'Services Page');
        break;
      default:
        trackEvent('Page', 'View', 'Home Page');
    }
  }, [location]);

  return null;
};

export default GoogleAnalytics; 
